import { RouteEnum } from "layout/TableConstructor/types";
import ExaminationList from "components/ExaminationList";
import qs from "qs";
import { useParams } from "react-router-dom";

const TestingListTab = () => {
  const { mapId } = useParams();

  const permanentFilter = {
    competencyMapId: mapId,
  };

  return (
    <ExaminationList
      exportRoute={RouteEnum.Trial}
      storageName='competencyMapTesting'
      settingsModalTitle='Список тестирований карты компетенций'
      permanentFilter={permanentFilter}
      navigateSearch={qs.stringify({ competencyMapId: mapId })}
    />
  );
};

export default TestingListTab;
